export default "__VITE_ASSET__BugPb6aE__"